import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillAiFlowStore } from '../state/bill-ai-flow.store';

interface BreadcrumbEntity { icon: string; label: string; value: string; }

@Component({
  selector: 'app-parent-context-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './parent-context-banner.component.html',
  styleUrl: './parent-context-banner.component.scss'
})
export class ParentContextBannerComponent {
  readonly state = inject(BillAiFlowStore);

  /**
   * Reactive breadcrumb. Recomputes whenever the parent context changes — e.g.
   * a Change Existing edit updates the LEN name or SA address via _context.set,
   * so the bar reflects the new label/street instead of the stale original.
   */
  readonly parentEntities = computed<BreadcrumbEntity[]>(() => {
    const context = this.state.getContext();
    if (!context) return [];

    const entities: BreadcrumbEntity[] = [];
    if (context.customerName) {
      entities.push({ icon: 'language', label: 'Customer', value: context.customerName });
    }
    if (context.lenName && (context.level === 'SERVICE_ADDRESS' || context.level === 'METER')) {
      entities.push({ icon: 'account_balance', label: 'Legal Entity', value: context.lenName });
    }
    if (context.serviceAddress && (context.level === 'SERVICE_ADDRESS' || context.level === 'METER')) {
      entities.push({ icon: 'home_work', label: 'Service Address', value: context.serviceAddress.street1 || '' });
    }
    return entities;
  });
}
